import { supabase } from '../lib/supabase';

// Generate VAPID keys using web-push generate-vapid-keys
const VAPID_PUBLIC_KEY = 'YOUR_VAPID_PUBLIC_KEY';

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications are not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: VAPID_PUBLIC_KEY
    });

    // Store subscription in localStorage for demo
    localStorage.setItem('pushSubscription', JSON.stringify(subscription));

    return subscription;
  } catch (error) {
    console.error('Error registering service worker:', error);
    throw error;
  }
}

export async function sendPushNotification(data: {
  title: string;
  body: string;
  data?: any;
}) {
  try {
    const subscription = localStorage.getItem('pushSubscription');
    if (!subscription) {
      console.warn('No push subscription found');
      return;
    }

    const { data: response, error } = await supabase.functions.invoke('push-notifications', {
      body: {
        subscription: JSON.parse(subscription),
        notification: data
      }
    });

    if (error) throw error;
    return response;
  } catch (error) {
    console.error('Error sending push notification:', error);
    throw error;
  }
}